<template>
  <page-header-wrapper>
    <a-card :bordered="false">
      <!-- 条件搜索 -->
      <div class="table-page-search-wrapper">
        <a-form layout="inline">
          <a-row :gutter="48">
            <a-col :md="6" :sm="24">
              <a-form-item label="姓名" prop="name">
                <a-input v-model="queryParam.name" placeholder="请输入姓名" allow-clear />
              </a-form-item>
            </a-col>
            <a-col :md="6" :sm="24">
              <a-form-item label="来源" prop="type">
                <a-select v-model="queryParam.type" placeholder="请选择来源" allowClear>
                  <a-select-option :value="0">用户端</a-select-option>
                  <a-select-option :value="1">师傅端</a-select-option>
                </a-select>
              </a-form-item>
            </a-col>
            <a-col :md="6" :sm="24">
              <a-form-item label="审核状态" prop="status">
                  <a-select v-model="queryParam.status" placeholder="请选择审核状态" allowClear>
                  <a-select-option :value="0">待审核</a-select-option>
                  <a-select-option :value="1">已审核</a-select-option>
                  <a-select-option :value="-1">审核驳回</a-select-option>
                </a-select>
              </a-form-item>
            </a-col>
            <a-col :md="6" :sm="24">
              <span class="table-page-search-submitButtons">
                <a-button type="primary" @click="handleQuery">
                  <a-icon type="search" />查询
                </a-button>
              </span>
            </a-col>
          </a-row>
        </a-form>
      </div>

      <!-- 操作 -->
      <div class="table-operations">
        <a-button
          type="primary"
          :disabled="single"
          v-hasPermi="['authentication:authentication:edit']"
          @click="$refs.createForm.handleUpdate(undefined, ids)"
        >
          <a-icon type="edit" />审核
        </a-button>
        <a-button
          type="danger"
          :disabled="multiple"
          v-hasPermi="['authentication:authentication:remove']"
          @click="handleDelete"
        >
          <a-icon type="delete" />删除
        </a-button>
        <table-setting
          :style="{ float: 'right' }"
          :table-size.sync="tableSize"
          v-model="columns"
          :refresh-loading="loading"
          @refresh="getList"
        />
      </div>

      <!-- 增加修改 -->
      <create-form ref="createForm" @ok="getList" />

      <!-- 数据展示 -->
      <a-table
        :loading="loading"
        :size="tableSize"
        rowKey="id"
        :columns="columns"
        :data-source="list"
        :row-selection="{ selectedRowKeys: selectedRowKeys, onChange: onSelectChange }"
        :pagination="false"
        :bordered="tableBordered"
      >
        <span slot="type" slot-scope="text, record">
          <a-tag v-if="record.type === 0" color="blue">用户端</a-tag>
          <a-tag v-else-if="record.type === 1" color="green">师傅端</a-tag>
          <span v-else>-</span>
        </span>

        <span slot="status" slot-scope="text, record">
          <a-tag v-if="record.status === 0" color="orange">待审核</a-tag>
          <a-tag v-else-if="record.status === 1" color="green">已审核</a-tag>
          <a-tag v-else-if="record.status === -1" color="red">审核驳回</a-tag>
          <span v-else>-</span>
        </span>

        <span slot="createTime" slot-scope="text, record">
          {{ parseTime(record.createTime) }}
        </span>

        <span slot="identityInverse" slot-scope="text, record">
          <img
            v-if="record.identityInverse"
            v-viewer
            class="auth-image"
            :src="record.identityInverse"
            preview="图片"
          />
        </span>

        <span slot="identityFront" slot-scope="text, record">
          <img
            v-if="record.identityFront"
            v-viewer
            class="auth-image"
            :src="record.identityFront"
            preview="图片"
          />
        </span>

        <span slot="operation" slot-scope="text, record">
          <a
            :disabled="record.status !== 0"
            v-hasPermi="['authentication:authentication:edit']"
            @click="$refs.createForm.handleUpdate(record, undefined)"
          >
            <a-icon type="edit" />审核
          </a>
          <a-divider type="vertical" v-hasPermi="['authentication:authentication:remove']" />
          <a
            v-hasPermi="['authentication:authentication:remove']"
            @click="handleDelete(record)"
          >
            <a-icon type="delete" />删除
          </a>
        </span>
      </a-table>

      <!-- 分页 -->
      <a-pagination
        class="ant-table-pagination"
        show-size-changer
        show-quick-jumper
        :current="queryParam.pageNum"
        :total="total"
        :page-size="queryParam.pageSize"
        :showTotal="total => `共 ${total} 条`"
        @showSizeChange="onShowSizeChange"
        @change="changeSize"
      />
    </a-card>
  </page-header-wrapper>
</template>

<script>
import { pageAuthentication, delAuthentication } from '@/api/authentication/authentication'
import CreateForm from './modules/CreateForm'
import { tableMixin } from '@/store/table-mixin'

export default {
  name: 'Authentication',
  components: {
    CreateForm
  },
  mixins: [tableMixin],
  data() {
    return {
      list: [],
      selectedRowKeys: [],
      selectedRows: [],
      // 非单个禁用
      single: true,
      // 非多个禁用
      multiple: true,
      ids: [],
      loading: false,
      total: 0,
      // 查询参数
      queryParam: {
        name: null,
        pageNum: 1,
        pageSize: 10
      },
      columns: [
        {
          title: '序号',
          dataIndex: 'id',
          ellipsis: true,
          align: 'center',
          width: 80,
          customRender: (text, record, index) => index + 1
        },
        {
          title: '来源',
          dataIndex: 'type',
          ellipsis: true,
          align: 'center',
          scopedSlots: { customRender: 'type' }
        },
        {
          title: '用户名称',
          dataIndex: 'userName',
          align: 'center'
        },
        {
          title: '姓名',
          dataIndex: 'name',
          align: 'center'
        },
        {
          title: '身份证号码',
          dataIndex: 'identification',
          align: 'center',
        },
        {
          title: '身份证正面',
          dataIndex: 'identityFront',
          align: 'center',
          scopedSlots: { customRender: 'identityFront' }
        },
        {
          title: '身份证反面',
          dataIndex: 'identityInverse',
          align: 'center',
          scopedSlots: { customRender: 'identityInverse' }
        },
        {
          title: '审核状态',
          dataIndex: 'status',
          ellipsis: true,
          align: 'center',
          scopedSlots: { customRender: 'status' }
        },
        {
          title: '拒绝原因',
          dataIndex: 'rejectReason',
          ellipsis: true,
          align: 'center'
        },
        {
          title: '提交时间',
          dataIndex: 'createTime',
          ellipsis: true,
          align: 'center',
          width: 180,
          scopedSlots: { customRender: 'createTime' }
        },
        {
          title: '备注',
          dataIndex: 'remark',
          ellipsis: true,
          align: 'center'
        },
        {
          title: '操作',
          dataIndex: 'operation',
          width: 150,
          align: 'center',
          scopedSlots: { customRender: 'operation' }
        }
      ]
    }
  },
  created () {
    if (!(this.$route.query && this.$route.query.id)) {
      this.getList()
    }
  },
  watch: {
    '$route.query.id': {
      handler (id) {
        this.openDetailFromRoute(id)
      },
      immediate: true
    }
  },
  methods: {
    openDetailFromRoute (id) {
      if (id == null || id === '') {
        return
      }
      const status = this.$route.query.status
      if (status !== undefined && status !== null && status !== '') {
        this.queryParam.status = status
      }
      this.queryParam.pageNum = 1
      this.getList()
      this.$nextTick(() => {
        if (this.$refs.createForm) {
          this.$refs.createForm.handleUpdate({ id }, undefined)
        }
        this.clearRouteDetailIdQuery()
      })
    },
    clearRouteDetailIdQuery () {
      const q = { ...(this.$route.query || {}) }
      if (!q.id) {
        return
      }
      delete q.id
      this.$router.replace({ path: this.$route.path, query: q }).catch(() => {})
    },
    /** 查询实名认证列表 */
    getList() {
      this.loading = true
      pageAuthentication(this.queryParam).then(response => {
        this.list = response.data.records
        this.total = response.data.total
        this.loading = false
      })
    },

    /** 搜索按钮操作 */
    handleQuery() {
      this.queryParam.pageNum = 1
      this.getList()
    },

    /** 分页大小改变 */
    onShowSizeChange(current, pageSize) {
      this.queryParam.pageSize = pageSize
      this.getList()
    },

    /** 页码改变 */
    changeSize(current, pageSize) {
      this.queryParam.pageNum = current
      this.queryParam.pageSize = pageSize
      this.getList()
    },

    /** 选择行改变 */
    onSelectChange(selectedRowKeys, selectedRows) {
      this.selectedRowKeys = selectedRowKeys
      this.selectedRows = selectedRows
      this.ids = this.selectedRows.map(item => item.id)
      this.single = selectedRowKeys.length !== 1
      this.multiple = !selectedRowKeys.length
    },

    /** 删除按钮操作 */
    handleDelete(row) {
      const that = this
      const ids = row.id || this.ids
      if (row.id) {
        this.ids.push(row.id)
      }
      this.$confirm({
        title: '确认删除所选中数据?',
        content: '当前选中编号为' + ids + '的数据',
        onOk() {
          const data = that.ids.map(id => ({ id }))
          return delAuthentication(data)
            .then(() => {
              that.onSelectChange([], [])
              that.getList()
              that.$message.success('删除成功', 3)
            })
        },
        onCancel() {
          // 取消清空删除ids列表
          that.ids = []
        }
      })
    }
  }
}
</script>

<style lang="less" scoped>
/* 认证图片样式 */
.auth-image {
  width: 48px;
  height: 48px;
  margin-top: 5px;
  margin-right: 5px;
  object-fit: cover;
  cursor: pointer;
}
</style>
